import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const NavigationIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="2 -1 16 16" fill="none">
            <g clipPath="url(#clip0_6650_5090)">
                <path
                    d="M10.8528 15.0371L15.7702 1.77119L15.774 1.75913C16.0763 0.880932 15.3146 0.00473251 14.4029 0.18197C14.3488 0.192495 14.2954 0.206726 14.2432 0.224564C14.2391 0.225476 14.235 0.226739 14.2311 0.228332L0.965216 5.1495C0.480097 5.31528 0.155817 5.77327 0.160604 6.28591L0.160604 6.30853C0.164598 6.83183 0.51021 7.29101 1.01197 7.43966L1.02705 7.44419L6.90893 9.09111L8.55585 14.973L8.56038 14.9881C8.83354 15.8758 9.96525 16.1349 10.5975 15.4545C10.7099 15.3334 10.7963 15.1906 10.8513 15.0348L10.8528 15.0371ZM7.98048 8.43958C7.92361 8.237 7.7653 8.07869 7.56272 8.02182L1.36714 6.28742L1.37996 6.28289L14.6391 1.36323L9.72092 14.6216L9.71639 14.6337L7.98048 8.43958Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_6650_5090">
                    <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)" />
                </clipPath>
            </defs>
        </svg>
    </IconWrapper>
)
